import React, { Component, Fragment } from "react";
import { connect } from "react-redux";

import { bool, func, string, oneOfType, element, arrayOf, shape } from "prop-types";
import { goBack, push } from "react-router-redux";
import { selectors as sessionSelectors } from "reducers/session";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { actions as depositActions, selectors as depositSelectors } from "reducers/deposits";
import { actions as productsActions } from "reducers/products";
import Container from "pages/_components/Container";
import InputSetProductAlias from "pages/accounts/_components/InputSetProductAlias";
import Head from "pages/_components/Head";
import MainContainer from "pages/_components/MainContainer";
import { resizableRoute } from "pages/_components/Resizable";
import { applyEmbeddedV3ShellLayoutState, clearEmbeddedV3ShellLayoutState } from "util/v3ShellLayoutSync";

import * as i18nUtils from "util/i18n";
import { getRutPathAccount } from "util/accounts";

class SetProductAlias extends Component {
    static propTypes = {
        selectedAccount: shape({}).isRequired,
        selectedDeposit: shape({}).isRequired,
        hidePlaceholder: bool,
        placeholder: string,
        onSave: func.isRequired,
        value: string.isRequired,
        children: oneOfType([element, arrayOf(element)]).isRequired,
        favorite: bool,
        dispatch: func.isRequired,
        isDesktop: bool,
        match: shape({}),
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        hidePlaceholder: true,
        favorite: null,
        placeholder: "",
        isDesktop: true,
        match: null,
        embeddedInV3Shell: false,
    };

    constructor(props) {
        super(props);
        this.titleRef = React.createRef();
    }

    componentDidMount() {
        const { isDesktop, match } = this.props;
        const {
            params: { id },
            url,
        } = match;

        if (this.titleRef.current) {
            this.titleRef.current.focus();
        }

        if (url.includes("account")) {
            accountsActions.readAccount(id);
        }

        if (url.includes("deposit")) {
            depositActions.readDeposit(id);
        }

        if (isDesktop) {
            this.handleBack();
        }
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop } = this.props;
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell || prevProps.isDesktop !== isDesktop)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { embeddedInV3Shell, dispatch } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop, match } = this.props;
        const isDeposit = match?.url?.includes("deposit");
        const titleKey = `products.alias.${isDeposit ? "deposit" : "account"}.edit.title.mobile`;
        const goBackPath = isDeposit ? `/deposits/${match.params.id}` : getRutPathAccount();
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: isDeposit ? ["deposits"] : ["accounts"],
            titleKey,
            goBackPath,
        });
    };

    handleEdit = () => {
        const { value } = this.props;

        this.setState({ value });
    };

    handleBack = () => {
        const { dispatch, embeddedInV3Shell, match } = this.props;
        if (embeddedInV3Shell && match?.url?.includes("deposit")) {
            dispatch(push(`/deposits/${match.params.id}`));
            return;
        }
        dispatch(goBack());
    };

    handleKeyDown = (event) => {
        const { value } = this.state;
        const { onSave } = this.props;

        if (event.key === "Enter" && onSave) {
            this.onSave();

            onSave(value);
        } else if (event.key === "Escape") {
            this.handleBack();
        }
    };

    handleSubmit = (newAlias) => {
        const { dispatch, ...rest } = this.props;
        dispatch(productsActions.changeProductAlias(newAlias, rest.match.params.id, true));
    };

    centerContentMobile = () => {
        const { ...rest } = this.props;
        return (
            <div>
                <h1 className="m-0">
                    {i18nUtils.get(
                        `products.alias.${
                            rest.match.path.includes("account") ? "account" : "deposit"
                        }.edit.title.mobile`,
                    )}
                </h1>
            </div>
        );
    };

    render() {
        const { selectedAccount, selectedDeposit, match } = this.props;
        const { url } = match;
        let defaultVal = "";
        if (url?.includes("account")) {
            defaultVal = selectedAccount?.productAlias;
        } else if (url?.includes("deposit")) {
            defaultVal = selectedDeposit?.productAlias;
        }

        const { embeddedInV3Shell, isDesktop } = this.props;

        return (
            <Fragment>
                <div className="height-40">
                    {!(embeddedInV3Shell && !isDesktop) && (
                        <Head
                            onBack={this.handleBack}
                            headerClassName="blue-main-header-mobile"
                            centerElement={this.centerContentMobile}
                            emptyRightOption
                        />
                    )}
                </div>
                <div className="mt-6 mr-2 ml-2">
                    <MainContainer shouldHideOnLoad className="main-container">
                        <div className="above-the-fold">
                            <Container fluid className="flex-grow align-items-center container--layout">
                                <div className="w-100 margin-top-safe-area mx-2">
                                    <InputSetProductAlias onSave={this.handleSubmit} defaultValue={defaultVal} />
                                </div>
                            </Container>
                        </div>
                    </MainContainer>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    loggedUser: sessionSelectors.getUser(state),
    selectedAccount: accountsSelectors.getSelectedAccount(state),
    selectedDeposit: depositSelectors.getSelectedDeposit(state),
});

export default connect(mapStateToProps)(resizableRoute(SetProductAlias));
